import { InputNumber } from "antd";
import { laariToMvr, mvrToLaari } from "../helpers/format";

// Displays/edits MVR; the value it emits is always integer laari (architecture.md §7).
export function MoneyInput({ valueLaari, onChangeLaari }: { valueLaari?: number; onChangeLaari?: (v: number) => void }) {
  return (
    <InputNumber
      value={laariToMvr(valueLaari)}
      onChange={(v) => onChangeLaari?.(mvrToLaari(v ?? 0))}
      min={0}
      step={0.01}
      precision={2}
      style={{ width: "100%" }}
      addonAfter="MVR"
    />
  );
}
